import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';

import { ModalCard } from 'partial/components/Modal';
import AsyncButton from 'modules/common/components/AsyncButton';
import FormPassword from 'partial/components/form/FormPassword';

import { useResetPass } from '../hooks';

const ConfirmPassword = ({ onClose, uuid, otherFields }) => {
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);
  const { values, setFieldValue } = useFormik({
    initialValues: {
      ...otherFields,
      password_confirmation: '',
    },
  });

  const onError = () => setPending(false);
  const onSuccess = (res) => {
    navigate(`/access-control/user-management/${res?.data?.data?.uuid}`);
    setPending(false);
    onClose();
  };

  const [isLoading, reset] = useResetPass(onSuccess, onError);

  const handleConfirmPass = () => {
    setPending(true);
    reset({
      ...values,
      id: uuid,
    });
  };
  return (
    <ModalCard size="sm" title="CONFIRM PASSWORD" onClose={onClose}>
      <div className="p-4 pt-2">
        <h5 className="pb-10 font-light">
          Please enter your password to continue.
        </h5>
        <FormPassword
          name="password_confirmation"
          value={values?.password_confirmation}
          onSetFieldValue={setFieldValue}
        />

        <div className="flex justify-end gap-2 pt-8 border-neutral-200">
          <AsyncButton
            className="font-[400] !text-neutral-500"
            color="outline"
            onClick={onClose}
          >
            Cancel
          </AsyncButton>
          <AsyncButton
            type="button"
            onClick={handleConfirmPass}
            className="font-[400]"
            color="outline"
            disabled={!values?.password_confirmation?.length}
            isLoading={pending || isLoading}
          >
            confirm
          </AsyncButton>
        </div>
      </div>
    </ModalCard>
  );
};

ConfirmPassword.propTypes = {
  uuid: PropTypes.string.isRequired,
  otherFields: PropTypes.instanceOf(Object).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ConfirmPassword;
